export function setLocalStorageItem(key: string, value: any) {
  localStorage.setItem(key, value);
  window.dispatchEvent(
    new CustomEvent('local-storage-change', { detail: { key, value } })
  );
}
